import { Component, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { nanoid } from 'nanoid';
@Component({
    selector: 'generic-error-modal',
    styleUrls: ['./generic-error-modal.style.scss'],
    templateUrl: './generic-error-modal.template.html',
    standalone: false
})
export class GenericErrorModal implements OnDestroy {
    @ViewChild('genericErrorModalButton') private genericErrorModalButton: ElementRef;
    @ViewChild('genericErrorModal') private genericErrorModal: ElementRef;
    public modalId = nanoid();

    public showGenericErrorModal() {
        this.genericErrorModalButton.nativeElement.click();
    }

    ngOnDestroy() {
        if (this.genericErrorModal.nativeElement.classList.contains('show')) {
            this.genericErrorModalButton.nativeElement.click();
        }
    }

}